import { Component, Input, OnInit, Output, EventEmitter, HostBinding } from '@angular/core';

import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ViewportScroller } from '@angular/common';

import { ScrollPositionService } from '../../../services/scroll-position.service';
import { ScoreService } from '../../../services/scores.service';
//import { PostMedia } from '../../interfaces/post-media.interface'; // Adjust the path as needed
import *  as Classes from '../../../classes/models.classes'

@Component({
    selector: 'app-post-detail',
    templateUrl: './post-detail.component.html',
    styleUrls: ['./post-detail.component.css']
})
export class PostDetailComponent implements OnInit {

    @Input() Username: string;
    @Input() UserID: number;
    @Input() postData: Classes.ShortsPosts;
    @Input() pageType!: string; 

    @HostBinding('class.ts-post-on-dashboard')
    get hostDashboardLayoutClass(): boolean {
        return this.pageType === 'dashboard';
    }

    @Output() postEditedOrDeleted = new EventEmitter<void>();

    /** Emitted when reactions change with server payload (e.g. like toggle). Parent can merge into feed. */
    @Output() reactionsUpdated = new EventEmitter<{ postId: number; reactions: any }>();

    @Output() mediaUrlsChange = new EventEmitter<any[]>();
    @Output() replyTypeChange = new EventEmitter<any>();
    @Output() postContent = new EventEmitter<any>();
    @Output() onSaveReactions = new EventEmitter<number>();      


    borders: boolean = true;

    UserPostsDataContent: Classes.ShortsPostSave;

    mediaUrls: any[] = [];
    selectedReplyType: any;  

    hasPostText: boolean = false; // Tracks whether there is post text to enable post button


    constructor(
        private scrollPositionService: ScrollPositionService,
        private viewportScroller: ViewportScroller,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.UserPostsDataContent = new Classes.ShortsPostSave();

        if (this.pageType === "quote") {
            this.borders = false;
        }

        if (this.pageType === "dashboard") {
            this.borders = false;
        }

    }

    updatePostContent(postContent: any) {
        this.UserPostsDataContent = postContent;
        if (postContent && postContent.length > 0) {
            this.hasPostText = true;
        }

    }

    updatePostMediaUrls(media: any[]) {
        this.mediaUrls = media.map(item => ({ ...item })); // Shallow copy to avoid reference sharing

    }

    updateReplyType(type: any) {
        this.selectedReplyType = type;
    }


    isTwitterPost(content: string): boolean {
        return content.includes('twitter-tweet');
    }

    isFacebookPostType(content: string): boolean {
        const facebookPatterns = ['facebook.com', 'fb.watch'];
        return facebookPatterns.some(pattern => content.includes(pattern));
    }

    isFacebookPost(content: string): boolean {
        const facebookPatterns = ['post.php'];
        return facebookPatterns.some(pattern => content.includes(pattern));
    }

    isFacebookEmbeddedPost(content: string): boolean {
        const facebookPatterns = ['iframe'];
        return facebookPatterns.some(pattern => content.includes(pattern));
    }

    navigateToPost(username: string, postId: number): void {
        // Save the current scroll position
        const currentPosition = this.viewportScroller.getScrollPosition();
        this.scrollPositionService.setScrollPosition(currentPosition);

        this.router.navigate([`${username}/posts/${postId}`]);
    }


    refreshPosts() {
        this.postEditedOrDeleted.emit();
    }

    /**
     * Bridge from app-reactions: forwards payload to parent for optimistic UI, or refreshes when no payload.
     */
    onReactionsUpdated(postId: number, updatedReactions?: any): void {
        if (updatedReactions !== undefined && updatedReactions !== null) {
            this.reactionsUpdated.emit({ postId, reactions: updatedReactions });
        } else {
            this.postEditedOrDeleted.emit();
        }
    }

    handleSave(saveType: number): void {
        this.mediaUrlsChange.emit(this.mediaUrls);
        this.replyTypeChange.emit(this.selectedReplyType);
        this.postContent.emit(this.UserPostsDataContent);
        this.onSaveReactions.emit(saveType);
    }
}
